import { InlineChildren } from '@doordash/design-language';
export var MINIMUM_CLICKABLE_HEIGHT = 36;
export var Sizes = {
  Large: {
    height: 8,
    width: 32,
    spacing: InlineChildren.Sizes.Medium
  },
  Medium: {
    height: 6,
    width: 24,
    spacing: InlineChildren.Sizes.Small
  },
  Small: {
    height: 4,
    width: 16,
    spacing: InlineChildren.Sizes.XSmall
  }
};